import React from 'react';
import SVGIcon from '../../assets/images/svg/SVGIcon';
import { Buttons } from './styles';

interface Props {
  onClick?: () => void;
  className?: string;
}

const Resbutton: React.FC<Props> = (Props) => {
  const { onClick, className, ...props } = Props;
  return (
    <Buttons onClick={onClick} className={className} {...props}>
      <SVGIcon name='plus-icon' width='20' height='20' viewBox='0 0 18 18' fill='var(--text-white)' />
    </Buttons>
  );
};

export default Resbutton;
